import React, { Component, PropTypes } from 'react'
import OrganizationCard from './OrganizationCard'


export default class OrganizationList extends Component {

  render() {
    let organizationList = ''

    organizationList = this.props.organizations.results.map((item) => {
      return <OrganizationCard key={item.id} item={item} />
    })

    return <div className="organizationsList organizationsListContainer">
      {organizationList}
    </div>

  }

}



// WEBPACK FOOTER //
// ./src/components/OrganizationList.jsx